import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@states/auth/auth.api";
import { NEWS } from "@utils/constants/cms/news.constants";

export const newsApi = createApi({
  reducerPath: "newsApi",
  tagTypes: ["News"],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllNews: builder.query<
      [],
      {
        page?: number;
        limit?: number;
        search?: string;
        status?: string | number;
      }
    >({
      query: ({ page = 1, limit = 10, search, status }) => {
        const queryParams = {
          url: NEWS.GET_ALL,
          params: { page, limit },
        } as any;

        if (search) {
          queryParams.params.search = search;
        }

        if (status !== undefined && status !== "") {
          queryParams.params.status = status;
        }

        return queryParams;
      },
    }),
    getNews: builder.query<any, { id: string | number }>({
      query: ({ id }) => `${NEWS.GET_ONE}${id}`,
    }),
    createNews: builder.mutation({
      query: (body) => ({
        url: NEWS.CREATE,
        method: "POST",
        body,
      }),
    }),
    updateNews: builder.mutation({
      query: ({ id, body }) => ({
        url: `${NEWS.UPDATE}${id}`,
        method: "PATCH",
        body,
      }),
    }),
    deleteNews: builder.mutation({
      query: (id) => ({
        url: `${NEWS.DELETE}${id}`,
        method: "DELETE",
      }),
    }),
  }),
  keepUnusedDataFor: 0,
});

export const {
  useGetAllNewsQuery,
  useGetNewsQuery,
  useCreateNewsMutation,
  useUpdateNewsMutation,
  useDeleteNewsMutation,
} = newsApi;
